import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef, useSlots } from 'vue';
import { Slot, Slots } from 'vue/types/v3-setup-context';
import { RouteLocationRaw } from 'vue-router';

import BrandIcon from '@/components/icons/BrandIcon.vue';

interface Props {
  icon?: string;
  label?: string;
  tag?: string;
  to?: RouteLocationRaw;
  disabled?: boolean;
  isButton?: boolean;
  iconOnLeft?: boolean;
}
interface Emits {
  (e: 'click', event: Event): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PrimaryButton',
  props: {
    icon: null,
    label: null,
    tag: { default: 'button' },
    to: null,
    disabled: { type: Boolean, default: false },
    isButton: { type: Boolean, default: true },
    iconOnLeft: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click', event: Event): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { icon?: string, label?: string, tag: string, to?: RouteLocationRaw, disabled: boolean, isButton: boolean, iconOnLeft: boolean }





const slots: Slots = useSlots();

const classes: ComputedRef<string> = computed(() => {
  const classes: string[] = ['button', 'primary'];
  if (!props.iconOnLeft) {
    classes.push('rev');
  }
  if (!props.label) {
    const defaultSlot: Slot | undefined = slots.default;
    if (!defaultSlot?.()?.[0]?.text?.trim()) {
      classes.push('iconOnly');
    }
  }
  return classes.join(' ');
});

const toObject: ComputedRef<RouteLocationRaw> = computed(() => {
  return props.to ? props.to : {};
});

function clicked(event: InputEvent): void {
  if (!props.disabled) {
    emit('click', event);
  }
}

return { __sfc: true,props, emit, slots, classes, toObject, clicked, BrandIcon }
}

})